<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-10 17:46:42
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-15 16:44:23
 * @Description: 公告内容
 -->
<template>
  <div class="announcement-content-wrapper">
    <h3 class="title">{{ title }}</h3>
    <p class="date">{{ date }}</p>
    <p class="line"></p>
    <div class="html-body" v-html="htmlText"></div>
  </div>
</template>
<script>
export default {
  name: 'announcement-content',
  data() {
    return {
      title: '',
      date: '',
      htmlText: ''
    };
  },
  created() {
    this.requestContent();
  },
  methods: {
    async requestContent() {
      const res = await this.$http.post('/cg/commonRequest', {
        method: 'pinfo.notice.detail',
        noticeid: this.$route.params.id,
        terminal: 4
      });
      if (res.code === 200) {
        this.title = res.data.title;
        this.date = res.data.issue_time;
        this.htmlText = res.data.body;
      }
    }
  }
};
</script>
<style lang="less">
.announcement-content-wrapper {
  padding: 20px;
  .title {
    text-align: center;
    font-size: 20px;
    line-height: 50px;
    color: #666;
    margin-bottom: 20px;
  }
  .date {
    text-align: center;
  }
  .line {
    border: 1px dashed #ccc;
    margin: 30px 0;
  }
}
</style>
